import React from 'react';
import { useSeriesId } from '@/hooks';

export type ButtonTextProps = {
  isSavingInProgress: boolean;
};

export const ButtonText: React.FC<ButtonTextProps> = ({
  isSavingInProgress,
}) => {
  const seriesId = useSeriesId();
  if (isSavingInProgress) return <span>saving...</span>;

  return seriesId ? <span>Saved</span> : <span>Save query</span>;
};
